<template>
  <v-container>
    <!-- Botón para abrir el dialog -->
    <v-tooltip left color="green darken-1">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          color="green darken-3"
          x-small
          text
          class="pa-0"
          @click="dialog = true"
        >
          <v-icon>fab fa-whatsapp</v-icon>
        </v-btn>
      </template>

      <span>Iniciar Chat</span>
    </v-tooltip>

    <!-- Dialog con tabs -->
    <v-dialog v-model="dialog" fullscreen>
      <v-card>
        <v-toolbar color="primary" dark class="py-0" height="40px">
          <v-toolbar-title>Contactar por WhatsApp</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false">
            <v-icon>fa-times</v-icon>
          </v-btn>
        </v-toolbar>

        <v-tabs v-model="tab" grow height="40px">
          <v-tab>
            <v-icon left>fa-user-tie</v-icon>
            Cliente
          </v-tab>
          <v-tab>
            <v-icon left>fa-hands-helping</v-icon>
            Proveedor
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-card flat>
              <v-card-text class="pa-1">
                <WhatsAppChat
                  :numero-asistencia="numeroAsistenciaComun"
                  :numero="setDefaultCode(numeroCliente)"
                  :numero-reenvio="setDefaultCode(numeroProveedor)"
                />
              </v-card-text>
            </v-card>
          </v-tab-item>

          <v-tab-item>
            <v-card flat>
              <v-card-text class="pa-1">
                <WhatsAppChat
                  :numero-asistencia="numeroAsistenciaComun"
                  :numero="setDefaultCode(numeroProveedor)"
                />
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Axios from "axios";
import WhatsAppChat from "./Minis/WhatsAppChat.vue";

export default {
  name: "WhatsAppDialog",
  components: {
    WhatsAppChat,
  },
  props: {
    numeroAsistenciaComun: {
      type: String,
      required: true,
    },
    numeroCliente: {
      type: String,
      required: true,
    },
    proveedorId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      tab: null,
      numeroProveedor: null,
    };
  },
  created() {
    this.getNumeroProveedor();
  },
  methods: {
    setDefaultCode(numero) {
      if (!numero) return "";

      let limpio = numero.replace(/[\s\-()]/g, "");

      if (limpio.startsWith("+503")) {
        return limpio;
      }

      if (limpio.startsWith("503")) {
        return `+${limpio}`;
      }

      return `+503${limpio}`;
    },
    getNumeroProveedor() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      Axios.get(
        "api/DetallexProveedores/ListarId/" + this.proveedorId,
        configuracion
      )
        .then((response) => {
          this.numeroProveedor = response.data[0].telefono;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>